import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, {
      to: { name: 'Styles' },
      class: "cd-sidenav-nav-link nav-link"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          fixedWidth: true,
          icon: "list-alt"
        }),
        _createTextVNode(_toDisplayString(_ctx.$t("appSideBar.styles")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: { name: 'systemConfiguration' },
      class: "cd-sidenav-nav-link nav-link"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          fixedWidth: true,
          icon: "edit"
        }),
        _createTextVNode(_toDisplayString(_ctx.$t("appSideBar.systemConfiguration")), 1)
      ]),
      _: 1
    })
  ]))
}